import React, {useState} from 'react';
import { ruleCheck } from './game-check';
import { useCareerContext } from '../career-context';
import CompletionPopup from '../completion-popup';

export default function RegulationGame() {
    const {
        isPopupOpen,
        setIsPopupOpen,
        handleError,
        handleNotification,
        startConfetti
    } = useCareerContext();
    const numRows = 15;
    const numCols = 20;
    const [design, setDesign] = useState(Array.from({ length: numRows }, () => Array(numCols).fill(0)));
    const [isRulePopup, setIsRulePopup] = useState(false);
    const tileToId = {
        'door-front': 1,
        'door-right': 1,
        'door-down': 1,
        'door-left': 1,
        'classroom': 2,
        'cafeteria': 3,
        'accessible-restroom': 4,
        'restroom': 5,
        'fire-exit': 6,
        'library': 7,
        'ramp': 8
    }


    function allowDrop(e) {
        e.preventDefault();
    }
    function drag(e) {
        const source = e.target.id.split(" ");
        // check if element is a tile or element
        if (source[0] === "element" || source[0] === "tile") {
            // set the source and tile type of the dragged element
            e.dataTransfer.setData("sourceId", e.target.id);
        }
    }
    function handleDrop(e) {
        e.preventDefault();
        var sourceId = e.dataTransfer.getData("sourceId");
        const source = sourceId.split(" ")[0];
        const target = e.currentTarget.id.split(" ")[0];
        var unpackedSource = sourceId.split(" ");
        var unpackedTarget = e.currentTarget.id.split(" ");
        // console.log(unpackedSource, unpackedTarget);
        if (source === "element") {
            if (target === "tile-holder") {
                // clear the tile
                e.currentTarget.innerHTML = "";
                // create a copy of element
                var nodeCopy = document.getElementById(sourceId).cloneNode(true);
                // get the tiles id
                nodeCopy.addEventListener('dragstart', drag)
                const tileId = `tile ${unpackedTarget[1]} ${unpackedTarget[2]}`;
                // set the id of the copy to the tile id
                nodeCopy.id = tileId;
                // Add tile to tile-holder
                e.currentTarget.appendChild(nodeCopy);
                // Update design
                var newDesign = design;
                newDesign[unpackedTarget[1]][unpackedTarget[2]] = tileToId[unpackedSource[1]];
                setDesign(newDesign);

            }
        } 
        else if (source === "tile") {
            
            if (target === "tile-holder") {
                // If tile and tileholder are same tile, do nothing
                if (unpackedSource[1] === unpackedTarget[1] && unpackedSource[2] === unpackedTarget[2]) {
                    return;
                }
                // Clear target tile
                e.currentTarget.innerHTML = "";
                // Move source tile to target tile
                e.currentTarget.appendChild(document.getElementById(sourceId));
                // Update source tile id
                document.getElementById(sourceId).id = `tile ${unpackedTarget[1]} ${unpackedTarget[2]}`
                // Update design
                var newDesign = design;
                newDesign[unpackedTarget[1]][unpackedTarget[2]] = design[unpackedSource[1]][unpackedSource[2]];
                newDesign[unpackedSource[1]][unpackedSource[2]] = 0;
                setDesign(newDesign);
            } else {
                // Clear the tile
                document.getElementById(sourceId).parentElement.innerHTML = "";
                // Update design
                var newDesign = design;
                newDesign[unpackedSource[1]][unpackedSource[2]] = 0;
                setDesign(newDesign);
            }
        }
        return;
    }

    function handleSubmit() {
        const result = ruleCheck(design);
        if (result ===  "Great job! You passed all the tests!") {
            setIsPopupOpen(true);
            startConfetti();
        } else {
            handleError(result);
        }
    }

    return (
        <div>
            {
                isPopupOpen &&
                <CompletionPopup title="Congratulations!" message="You successfully followed building codes and regulations to give the students of Harmony Middle School a safe school experience!" hidePopup={() => setIsPopupOpen(false)} />
            }
            {/* TODO check screen width */}
            <h1>Codes and Regulations</h1>
            <p>Architects also need to follow codes and regulations. These codes vary in different places, but you can get a feel of what it’s like to design under constraints with this mini-game.</p>
            <h2>Harmony Middle School</h2>
            <p>Given your impressive work from before, a school district has asked you to help them design the layout of a middle school. Because there are many regulations and codes involved with publicly-used buildings, your goal is to design a middle school that follows these codes. <strong>Drag and drop building elements while following codes and regulations to design a safe school.</strong></p>
            <div className='center' style={{marginBottom: "20px"}}>
                <button className='primary-btn' onClick={()=>setIsRulePopup(true)}>Rules</button>
            </div>
            {isRulePopup && 
                <div className="popup-overlay" onClick={()=>setIsRulePopup(false)} style={{display: "grid", placeContent: "center"}}>
                    <div className="popup-content" onClick={(e) => e.stopPropagation()} style={{width: "600px", maxWidth: "90vw", height: "95vh", margin: "0 auto"}}>
                        <button className="close-button" onClick={()=>setIsRulePopup(false)}>×</button>
                        <div style={{height: "20px"}}></div>
                        <div >
                            <h2>Instructions</h2>
                            <div style={{textAlign: "left"}}>
                                <p>1. Drag and drop building elements to create a design. You can place elements next to each other to represent the same element, for example, 5 connected classroom tiles represents one classroom.</p>
                                <p>2. Drag a tile back to where it came from in the item tray to remove it.</p>
                                <p>3. Press submit to check your design.</p>
                            </div>
                            
                            <h2>Rules</h2>
                            <div style={{textAlign: "left"}}>
                                <p>1. Each tile is a 100 square foot region that can safely hold 10 people. This will help you determine sizing of elements.</p>
                                <p>2. There must be a cafeteria that can hold 160 people.</p>
                                <p>3. There must be at least 3 restrooms.</p>
                                <p>4. There must be a library that can hold 120 people.</p>
                                <p>5. There must be at least one accessible restroom.</p>
                                <p>6. There must be at least 2 fire exits. The exits must be at least 15 squares away from each other.</p>
                                <p>7. There must be a ramp leading into the library and accessible bathroom.</p>
                                <p>8. Each main enterance (north, south, east, west) must have a double door. Each gathering space (classroom, library, cafeteria) must have a door.</p>
                                <p>9. There must be 5 classrooms, where 40 people can occupy each classroom.</p>
                            </div>
                        </div>
                        

                    </div>
                </div>
            }
            <div className="regulation-game-wrapper center">
                <div className="tiles">
                    {
                        design.map((row, i) => (
                            row.map((col, j) => (
                            <div
                                className='tile-holder'
                                id={`tile-holder ${i} ${j}`}
                                key={`regulation ${i}-${j}`}
                                onDrop={handleDrop}
                                onDragOver={allowDrop}
                            ></div>
                            ))
                        ))
                        }

                </div>
                <div className="elements row">
                    <div className='element-wrapper'>
                        <span>Door</span>
                        <div id="element door-front" className='element' draggable="true" onDrop={handleDrop} onDragOver={allowDrop} onDragStart={drag} >
                            <img draggable="false" src={require("../../img/architect/door-front.png")} style={{width: "45px"}} alt="door"/>
                        </div>
                    </div>

                    <div className='element-wrapper' style={{marginTop: "auto"}}>
                        <div id="element door-right" className='element' draggable="true" onDrop={handleDrop} onDragOver={allowDrop} onDragStart={drag} >
                            <img draggable="false" src={require("../../img/architect/door-right.png")} style={{width: "45px"}} alt="door"/>
                        </div>
                    </div>

                    <div className='element-wrapper' style={{marginTop: "auto"}}>
                        <div id="element door-down" className='element' draggable="true" onDrop={handleDrop} onDragOver={allowDrop} onDragStart={drag} >
                            <img draggable="false" src={require("../../img/architect/door-down.png")} style={{width: "45px"}} alt="door"/>
                        </div>
                    </div>

                    <div className='element-wrapper' style={{marginTop: "auto"}}>
                        <div id="element door-left" className='element' draggable="true" onDrop={handleDrop} onDragOver={allowDrop} onDragStart={drag} >
                            <img draggable="false" src={require("../../img/architect/door-left.png")} style={{width: "45px"}} alt="door"/>
                        </div>
                    </div>


                    <div className='element-wrapper'>
                        <span>Classroom</span>
                        <div id="element classroom" className='element' draggable="true" onDrop={handleDrop} onDragOver={allowDrop} onDragStart={drag} >
                            <img draggable="false" src={require("../../img/architect/classroom.png")} style={{width: "45px"}} alt="classroom"/>
                        </div>
                    </div>

                    <div className='element-wrapper'>
                        <span>Cafeteria</span>
                        <div id="element cafeteria" className='element' draggable="true" onDrop={handleDrop} onDragOver={allowDrop} onDragStart={drag} >
                            <img draggable="false" src={require("../../img/architect/cafeteria.png")} style={{width: "45px"}} alt="cafeteria"/>
                        </div>
                    </div>

                    <div className='element-wrapper'>
                        <span>Accessible Restroom</span>
                        <div id="element accessible-restroom" className='element' draggable="true" onDrop={handleDrop} onDragOver={allowDrop} onDragStart={drag} >
                            <img draggable="false" src={require("../../img/architect/accessible-restroom.png")} style={{width: "45px"}} alt="accessible-restroom"/>
                        </div>
                    </div>

                    <div className='element-wrapper'>
                        <span>Restroom</span>
                        <div id="element restroom" className='element' draggable="true" onDrop={handleDrop} onDragOver={allowDrop} onDragStart={drag} >
                            <img draggable="false" src={require("../../img/architect/restroom.png")} style={{width: "45px"}} alt="restroom"/>
                        </div>
                    </div>

                    <div className='element-wrapper'>
                        <span>Fire Exit</span>
                        <div id="element fire-exit" className='element' draggable="true" onDrop={handleDrop} onDragOver={allowDrop} onDragStart={drag} >
                            <img draggable="false" src={require("../../img/architect/fire-exit.png")} style={{width: "45px"}} alt="fire-exit"/>
                        </div>
                    </div>

                    <div className='element-wrapper'>
                        <span>Library</span>
                        <div id="element library" className='element' draggable="true" onDrop={handleDrop} onDragOver={allowDrop} onDragStart={drag} >
                            <img draggable="false" src={require("../../img/architect/library.png")} style={{width: "45px"}} alt="library"/>
                        </div>
                    </div>

                    <div className='element-wrapper'>
                        <span>Ramp</span>
                        <div id="element ramp" className='element' draggable="true" onDrop={handleDrop} onDragOver={allowDrop} onDragStart={drag} >
                            <img draggable="false" src={require("../../img/architect/ramp.png")} style={{width: "45px"}} alt="ramp"/>
                        </div>
                    </div>


                    
                    
                  
                </div>
                <div>
                    <button className="primary-btn" onClick={handleSubmit}>Submit</button>
                </div>
            </div>
        </div>
    )
}